import { render, staticRenderFns } from "./UserShippingAddress.vue?vue&type=template&id=e7ffebe4"
import script from "./UserShippingAddress.vue?vue&type=script&lang=js"
export * from "./UserShippingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "c0439d0c"
  
)

export default component.exports